import { Button, Card, Col, Divider, Input, Progress, Rate, Row, Tag, Tooltip } from "antd";
import { Column, RingProgress } from "@ant-design/charts";
import { ArrowRightOutlined, DoubleRightOutlined, DownloadOutlined, ForwardOutlined, LineChartOutlined, SearchOutlined, ShopOutlined, StarFilled, StarOutlined } from "@ant-design/icons";
import MathUtils from "../../../../common/utils/MathUtils";
import { useTranslation } from "react-i18next";
import { getColor } from "../../../../common/utils/ColorRate";
import moment from "moment";
import { FilterDropdownProps } from "antd/lib/table/interface";
import { Location, LocationCardCompacted } from "../../../components/model/business/FieldsGroup";
import { SpinLZ } from "../../../components/design/Spinner/SpinLZ";
import TableLZM from "../../../components/design/table/TableLZM";
import { Increment } from "../../../../common/utils/Increment";
import { ColorStar, ColorStarExtended } from "../../../../common/utils/ColorStar";
import { useContext } from "react";
import { DrawerContext } from "../../../../store/DrawerContext/DrawerContext";
import { CSVDownload } from "../../../../common/utils/CSVDownload";
import { TableFilter } from "../../../../common/utils/FilterUtils";
import { PERIOD } from "./BlockReviewsKpis";

export const BlockReviewsByLocation = (props: {data: any, showButtons: boolean, period: string, recentPeriod: string}) => {

	const { setLocationReviewsStatsDrawer} = useContext(DrawerContext)

    const columns: any = [	
        {
			title: 'Nota',
			key: 'rateAvgNew',			
			align: 'center',
			sorter: (a: any, b: any) => b.reviewsKPIs?.rateAvgNew - a.reviewsKPIs?.rateAvgNew,
			render: (text: string, record: any) => (
                <Tooltip title={
					<div>
						<div><StarFilled style={{color:'orange'}}/><StarFilled style={{color:'orange'}}/><StarFilled style={{color:'orange'}}/><StarFilled style={{color:'orange'}}/><StarFilled style={{color:'orange'}}/> {record.reviewsKPIs.numberOfReviews5} reseñas</div>
						<div><StarFilled style={{color:'orange'}}/><StarFilled style={{color:'orange'}}/><StarFilled style={{color:'orange'}}/><StarFilled style={{color:'orange'}}/><StarFilled style={{color:'lightgrey'}}/> {record.reviewsKPIs.numberOfReviews4} reseñas</div>
						<div><StarFilled style={{color:'orange'}}/><StarFilled style={{color:'orange'}}/><StarFilled style={{color:'orange'}}/><StarFilled style={{color:'lightgrey'}}/><StarFilled style={{color:'lightgrey'}}/> {record.reviewsKPIs.numberOfReviews3} reseñas</div>
						<div><StarFilled style={{color:'orange'}}/><StarFilled style={{color:'orange'}}/><StarFilled style={{color:'lightgrey'}}/><StarFilled style={{color:'lightgrey'}}/><StarFilled style={{color:'lightgrey'}}/> {record.reviewsKPIs.numberOfReviews2} reseñas</div>
						<div><StarFilled style={{color:'orange'}}/><StarFilled style={{color:'lightgrey'}}/><StarFilled style={{color:'lightgrey'}}/><StarFilled style={{color:'lightgrey'}}/><StarFilled style={{color:'lightgrey'}}/>{record.reviewsKPIs.numberOfReviews1} reseñas</div>
					</div>}>

					{record.reviewsKPIs?.numberOfReviews > 0 ? 
						<>
							<div style={{ display: 'flex', justifyContent: 'center' }}>
								<ColorStar
									style={{ fontSize: '18px' }}
									value={record.reviewsKPIs?.rateAvgNew}/>								
							</div>
							<small>{record.reviewsKPIs?.numberOfReviews} reseñas</small>
						</>
						:
						<small style={{color:'lightgrey'}}><i>Sin datos {PERIOD[props.recentPeriod]}</i></small>
					} 

				</Tooltip>)			
		},		
		{
			title: 'Establecimiento',
			key: 'location',				
			width: '300px',					
			sorter: (a: any, b: any) => a.title?.localeCompare(b.title),
			filterDropdown: TableFilter,
			filterIcon: () => {
			  return <SearchOutlined />;
			},
			onFilter: (value: any, record: any) => {
				return record.title?.toLowerCase().includes(value?.toLowerCase()) 
				|| record.administrativeArea?.toLowerCase().includes(value?.toLowerCase())
				|| record.locality?.toLowerCase().includes(value?.toLowerCase());
			},
			render: (text: string, record: any) => (
				<LocationCardCompacted location={record}/>									
			)
		},			
        {
			title: 'Nota Real',
			key: 'rateAvgOld',			
			align: 'center',
			sorter: (a: any, b: any) => b.reviewsKPIs?.rateAvgOld - a.reviewsKPIs?.rateAvgOld,
			render: (text: string, record: any) => (
				<Tooltip title="La nota media de las reseñas sin redondeo, Google muestra solo un decimal">
					{record.reviewsKPIs?.numberOfReviews > 0 ? 
					<>
						<b style={{color:'slategrey'}}>
							<ColorStarExtended
								style={{ fontSize: '18px' }}
								value={record.reviewsKPIs?.rateAvgNew}/>
						</b>
						{record.reviewsKPIs?.rateAvgIncrement && 
								<small style={{color:'steelblue'}}><Increment value={20 * record.reviewsKPIs.rateAvgIncrement} numberOfDecimals={3}/>{PERIOD[props.recentPeriod]}</small>
							}				
					</>
					:
					<small style={{color:'lightgrey'}}><i>Sin datos {PERIOD[props.recentPeriod]}</i></small>}
				</Tooltip>
			)			
		},	
        {
			title: 'Nota Objetivo',
			key: 'rateTarget',				
			align: 'center',		
			//sorter: (a: any, b: any) => b.reviewsKPIs?.rateAvgOld - a.reviewsKPIs?.rateAvgOld,
			render: (text: string, record: any) => (
                <>				
				{record.reviewsKPIs?.numberOfReviewsToRateTarget > 0 && 
				<>
					<small style={{display:'flex', justifyContent:'space-between', alignItems:'center', color:'slategrey'}}>						
						<b><StarFilled/>{record.reviewsKPIs?.rateAvgNew.toFixed(1)}</b><Progress style={{margin:'0px 12px'}} size="small" type="line" strokeColor='steelblue' trailColor="FloralWhite" percent={Math.round(100 * record.reviewsKPIs?.percentToTarget)} /><b><StarFilled/>{record.reviewsKPIs?.rateTarget.toFixed(1)}</b>	
					</small>
					<small style={{color:'slategrey'}}>
						<i>Faltan {record.reviewsKPIs?.numberOfReviewsToRateTarget} reseñas de 5 para {record.reviewsKPIs?.rateTarget.toFixed(1)}</i>
					</small>
				</>
				}				
				</>)			
		},				
		{
			title: 'Frecuencia',
			key: 'recentReviewsPerMonth',
			align: 'center',			
			render: (text: string, record: any) => 
			<>
				{record.reviewsKPIs?.numberOfRecentReviews > 0 ? 
				<>
					<div>{record.reviewsKPIs?.reviewsPerMonth?.toFixed(1)} reseñas/mes</div>
					<small style={{color:'steelblue'}}>{'+'}{record.reviewsKPIs?.numberOfRecentReviews} reseñas {PERIOD[props.recentPeriod]}</small>					
				</>
				:
					<small style={{color:'lightgrey'}}><i>Sin datos {PERIOD[props.recentPeriod]}</i></small>
				}
			</>			
		},		        
		{
			title: '%Contestadas',
			key: 'recentRepliedRatio',
			dataIndex: 'recentRepliedRatio',
			align: 'center',
			render: (text: string, record: any) => (
				<>
					{record.reviewsKPIs?.numberOfRecentReviews > 0 &&
						<>
							<div><Progress width={50} type="circle" strokeColor='steelblue' percent={Math.round(100 * record.reviewsKPIs?.recentRepliedRatio)} /></div>
							<><small style={{color:'steelblue'}}><i>{PERIOD[props.recentPeriod]}</i></small></>
						</>
					}
				</>
			)
		},
		{
			title: '',
			key: 'buttons',			
			align: 'center',
			render: (text: string, record: any) => (				
				<div style={{display:'flex', justifyContent:'space-between'}}>	
					<Button size='small' type='link' onClick={()=>{setLocationReviewsStatsDrawer({location: record.location, selectedType: props.period})}}>    
						<i>Ver detalle {<DoubleRightOutlined/>}</i>
					</Button>
				</div>
			)
		}
	]
	
	const transformarDatos = (datos: any): any[] => {	

		return datos.map((dato : any) => ({
			'Nombre': dato.title,
			'Localidad': dato.locality,
			'Áream Administrativa': dato.administrativeArea,
			'Dirección': dato.addressLine,
			'#Reseñas': dato.reviewsKPIs.numberOfReviews,
		  	'Nota Media': dato.reviewsKPIs.rateAvg?.toFixed(1),
			'Nota Media Real': dato.reviewsKPIs.rateAvg?.toFixed(4),
			'#Contestadas': dato.reviewsKPIs.replied,
			'#Pendientes': dato.reviewsKPIs.numberOfPendingReviews,
			'#Reseñas para objetivo': dato.reviewsKPIs.numberOfReviewsToRateTarget?.toFixed(1),
			'Nota Objetivo': dato.reviewsKPIs.rateTarget?.toFixed(1),
			'#Reseñas/mes': dato.reviewsKPIs.reviewsPerMonth?.toFixed(1),
			'#1 estrellas': dato.reviewsKPIs.numberOfReviews1,
			'#2 estrellas': dato.reviewsKPIs.numberOfReviews2,
			'#3 estrellas': dato.reviewsKPIs.numberOfReviews3,
			'#4 estrellas': dato.reviewsKPIs.numberOfReviews4,
			'#5 estrellas': dato.reviewsKPIs.numberOfReviews5,
			[`#Reseñas [${PERIOD[props.recentPeriod]}]`]: dato.reviewsKPIs.numberOfRecentReviews,
			[`Nota Media [${PERIOD[props.recentPeriod]}]`]: dato.reviewsKPIs.recentRateAvg?.toFixed(1),
			[`Ratio de Respuesta [${PERIOD[props.recentPeriod]}]`]: dato.reviewsKPIs.recentRepliedRatio?.toFixed(1),
			[`#Contestadas [${PERIOD[props.recentPeriod]}]`]: dato.reviewsKPIs.recentReplied,
			[`#Pendientes [${PERIOD[props.recentPeriod]}]`]: dato.reviewsKPIs.numberOfRecentPendingReviews
		}));
	  };
	  
    return (      
		<>
			<TableLZM 
				rowKey='location'
				scroll={{ x: true }}						
				columns={columns}
				dataSource={props.data}
				loading={false}/>
				{props.showButtons && <CSVDownload dataSource={transformarDatos(props.data)} title="Descargar CSV" fileName={`Datos de reseñas por local.csv`}/>			}
		</>  
    )
}